// extracted by mini-css-extract-plugin
export default {"Logo":"webpack-pages-LibKey-LibkeyLibrarySection-LibkeyLibrarySection-module__Logo"};